import jump from 'jump.js';
import { getQueryVariable } from '../utils/query';

const JUMP_OFFSET = 300;

const stopHeadroomOnHashchange = () => {
  document.querySelectorAll('.header--initialized').forEach($el => $el.classList.add('headroom--frozen'));
};

const removeFrozenAfterJumpIsFinished = () => {
  document.querySelectorAll('.header--initialized').forEach($el => $el.classList.remove('headroom--frozen'));
};

function addScrollEventListener($el) {
  $el.addEventListener('click', (event) => {
    // No href? No action
    if (!$el.getAttribute('href')) {
      return;
    }
    // Prevent default action
    event.preventDefault();

    // // Add hash to history
    // history.replaceState(false, false, $el.getAttribute('href'));

    // Jump to element
    stopHeadroomOnHashchange();
    jump($el.getAttribute('href'), {
      offset: -JUMP_OFFSET,
      duration: 500,
      callback: removeFrozenAfterJumpIsFinished,
    });
  });

  // Don't set focus state
  $el.addEventListener('mousedown', e => e.preventDefault());
}

window.addEventListener('load', () => {
  document.querySelectorAll('.js-scroll-to, [data-scroll="true"]').forEach(($el) => {
    addScrollEventListener($el);
  });
});

const jumpToLocation = (id) => {
  stopHeadroomOnHashchange();
  if (document.getElementById(id)) {
    jump(document.getElementById(id), {
      offset: -JUMP_OFFSET,
      duration: 0,
      callback: removeFrozenAfterJumpIsFinished,
    });
  }
};

const getLocationAndJump = () => {
  if (location.hash) {
    const hashId = location.hash.substr(1);
    jumpToLocation(hashId);
    return;
  }
  const queryId = getQueryVariable('section');
  if (queryId && document.getElementById(queryId)) {
    jumpToLocation(queryId);
  }
};

// Catch hash urls or queries on load
window.addEventListener('load', () => getLocationAndJump());

// Catch other changes in hash value
window.addEventListener('hashchange', () => getLocationAndJump());



// WEBPACK FOOTER //
// ./src/javascripts/shared/anchor-scroll.js